import React from 'react';

const Button = ({onClick, content, className}) => (
  <button className={className} onClick={onClick} type="button">
    {content}
  </button>
);

export default Button;
